import "../../IssuancePanel.css";

import { ActionButtons, Column, ErrorBox, Modal, Row } from "../../../../widget";
import { useDeleteIssuancePanel } from "./useDeleteIssuanceModal";

interface DeleteIssuanceModalProps {
  onClose: () => void;
  show: boolean;
  rowVersion?: number;
  issuanceUuid?: string;
  handleRefresh: () => void;
}

export const DeleteIssuanceModal = ({
  onClose,
  show,
  rowVersion,
  issuanceUuid,
  handleRefresh,
}: DeleteIssuanceModalProps): JSX.Element => {
  const { handleDeleteIssuance, isHandleDeleteIssuanceLoading, showIssuanceTransactionWarning, errors, handleCancel } =
    useDeleteIssuancePanel({
      onClose,
      rowVersion,
      issuanceUuid,
      handleRefresh,
    });
  return (
    <Modal show={show} title="Delete issuance?" onClose={handleCancel}>
      <form onSubmit={(e) => handleDeleteIssuance(e)}>
        {/* BR-02904: the server refuses deletion where live sales or reservations exist. The modal
            stays open so the refusal is readable. */}
        {errors && errors.length > 0 && (
          <Row spacingV="l" align="center" justify="center">
            <Column span={9}>
              <ErrorBox text={errors.map((error) => error.message)} />
            </Column>
          </Row>
        )}
        <Row spacingV="l">
          <Column span={12} align="center" justify="center">
            {showIssuanceTransactionWarning ? (
              <>
                <p className="DeleteIssuanceMessage">
                  This issuance has related transactions and deleting it may invalidate these records.
                </p>
                <p className="DeleteIssuanceMessage">This action cannot be undone</p>
              </>
            ) : (
              <p className="DeleteIssuanceMessage">This action cannot be undone</p>
            )}
          </Column>
        </Row>
        <div className="DeleteIssuanceActions">
          <ActionButtons submitButtonLabel="Delete" onCancel={handleCancel} isLoading={isHandleDeleteIssuanceLoading} />
        </div>
      </form>
    </Modal>
  );
};
